import { getPaddingX, getPaddingY } from '$lib/global/helper/layout';
import { cn } from '$lib/utils/cn';

import { LOGO_GAP_X_PX } from '../constants';

import type { BrandSpacing, Theme } from '$lib/types/Theme';

export interface ResolvedLogosStyling {
    logoGapXPx: number | undefined;
    paddingClass: string | undefined;
}

interface Params {
    theme: Theme;
}

const resolveLogoGapXPx = (theme: Theme): number | undefined => {
    if (theme.blockGap) {
        return LOGO_GAP_X_PX[theme.blockGap as BrandSpacing];
    }

    return undefined;
};

const resolvePaddingClass = (theme: Theme): string | undefined => {
    const className = cn(
        theme.paddingX ? getPaddingX(theme.paddingX as BrandSpacing) : undefined,
        theme.paddingY ? getPaddingY(theme.paddingY as BrandSpacing) : undefined,
    );

    return className || undefined;
};

export const resolveLogosStyling = ({ theme }: Params): ResolvedLogosStyling => ({
    logoGapXPx: resolveLogoGapXPx(theme),
    paddingClass: resolvePaddingClass(theme),
});
